import api from './api';

/**
 * 群关系分析服务
 */
const groupRelationshipService = {
  /**
   * 获取所有群主的群关系概览
   * @param {string} startDate - 开始日期 (YYYY-MM-DD)
   * @param {string} endDate - 结束日期 (YYYY-MM-DD)
   * @param {string} ownerUserid - 群主企微userid（可选）
   * @returns {Promise<Array>} 群主关系概览列表
   */
  getGroupOverview: async (startDate, endDate, ownerUserid) => {
    try {
      const params = {};
      if (startDate) {
        params.startDate = startDate;
      }
      if (endDate) {
        params.endDate = endDate;
      }
      if (ownerUserid) {
        params.ownerUserid = ownerUserid;
      }

      const response = await api.get('/wework/group/relationship/overview', { params });
      return response.data;
    } catch (error) {
      console.error('获取群主关系概览失败:', error);
      throw error;
    }
  }
};

export default groupRelationshipService;
